import React from 'react';

import {FormItemSkeleton, SkeletonItem} from 'src/components/skeleton';

export const AdminRoleSelectSkeleton = () => (
    <FormItemSkeleton labelWidth={70}>
        <SkeletonItem width={400} height={32}/>
    </FormItemSkeleton>
);
